import { Component, inject, Input } from '@angular/core';

import { StateService } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';

import { PublicHomeTemplateType } from 'rev-portal/branding/BrandingSettings.Contract';

import { AppBootstrapService } from 'rev-shared/bootstrap/AppBootstrap.Service';
import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { PORTAL_MEDIA_BROWSE_STATE } from 'rev-shared/bootstrap/AppStateNames';

import { BrandingSettings } from './BrandingSettings.Contract';
import { ThemeService } from './Theme.Service';
import { BrandingService } from './Branding.Service';

@Component({
	selector: 'branding-preview-button',
	template: `
		<button
			type="button"
			(click)="setPreviewMode()"
			vbBtnPrimary
		>
			{{ ( isPublicHomePreview ? 'Branding_PreviewButtonLabel_Public' : 'Branding_PreviewButtonLabel' ) | translate }}
		</button>
	`,
	standalone: false
})
export class BrandingPreviewButtonComponent {
	@Input() public isPublicHomePreview: boolean;
	@Input() private readonly brandingSettings: BrandingSettings;

	private readonly $state = inject(StateService);
	private readonly AppBootstrapService = inject(AppBootstrapService);
	private readonly ThemeService = inject(ThemeService);
	private readonly BrandingService = inject(BrandingService);
	private readonly DialogService = inject(DialogService);
	private readonly TranslateService = inject(TranslateService);

	public setPreviewMode(): void {
		const { state, params } = this.AppBootstrapService.getAppLandingState();
		const settings = this.BrandingService.readBrandingSettings(this.brandingSettings);

		const previewState = this.isPublicHomePreview && settings.publicHomeSettings?.homeTemplateType === PublicHomeTemplateType.Default
			? PORTAL_MEDIA_BROWSE_STATE
			: state;

		const goToPreviewMode = () => {
			this.ThemeService.setPreviewMode(settings);
			this.$state.go(
				previewState,
				{ ...params, isGuestMode: this.isPublicHomePreview },
				{ reload: true }
			).catch(error => {
				this.ThemeService.endPreviewMode();
				console.log('Error setting preview mode: ', error);
			});
		};

		if (this.isPublicHomePreview) {
			this.DialogService.openConfirmationDialog({
				message: this.TranslateService.instant('Branding_PreviewButtonLabel_Public_Msg'),
				title: this.TranslateService.instant('Branding_PreviewButtonLabel_Public'),
				actionText: this.TranslateService.instant('Ok')
			}).result
				.then(goToPreviewMode);
		} else {
			goToPreviewMode();
		}
	}

}
